import { BrowserRouter, Routes, Route } from "react-router-dom";
import Main from "./Main";


const Routers = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Main/>}/>
                <Route path="/check" element={<Main mesage="check"/>}/>
            </Routes>
        </BrowserRouter>
    )
}
export default Routers